module.exports = "<div class=\"referrer_link\"><a class=\"referrer_link_url\" href=\"{{href}}\" target=\"_blank\">{{href}}</a></div>";